module.exports = __webpack_public_path__ + "static/img/bc-ydzz.e5b9e1f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/bc/bc-ydzz.png
// module id = Mrsq
// module chunks = 0